import './ToggleSwitchWithLabel.scss';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { S_FieldLabel } from '../../../design/labels/fieldLabel/S_FIeldLabel';

interface IToggleSwitchWithLabelProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}

export const ToggleSwitchWithLabel = ({ label, disabled, checked, onChange }: IToggleSwitchWithLabelProps): ReactElement => (
  <div className='toggle-switch-with-label'>
    <S_FieldLabel>{label}</S_FieldLabel>
    <div className='form-group-control'>
      <label className='switch'>
        <input
          className='switch-input'
          type='checkbox'
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={classNames('switch-slider', {
            'switch-slider-disabled': disabled,
          })}
        />
      </label>
    </div>
  </div>
);
